export default __webpack_public_path__ + "static/media/headline-bg.bf7e78a0.jpg";